import LegalLayout, { LegalFooter } from "../layouts/LegalLayout";

const styles = {
  wrapper: {
    minHeight: "100vh",
    background: "#f4f7fe",
    fontFamily: "Arial, sans-serif",
  },
  navbar: {
    background: "#fff",
    padding: "14px 32px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    boxShadow: "0 2px 8px rgba(0,0,0,0.07)",
    position: "sticky",
    top: 0,
    zIndex: 100,
  },
  navLogo: {
    fontSize: 20,
    fontWeight: 800,
    color: "#4318FF",
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    gap: 8,
  },
  navLinks: {
    display: "flex",
    alignItems: "center",
    gap: 24,
    listStyle: "none",
    margin: 0,
    padding: 0,
  },
  navLink: {
    color: "#374151",
    textDecoration: "none",
    fontSize: 14,
    fontWeight: 500,
  },
  navLoginBtn: {
    background: "#4318FF",
    color: "#fff",
    border: "none",
    borderRadius: 8,
    padding: "8px 20px",
    fontSize: 14,
    fontWeight: 700,
    cursor: "pointer",
    textDecoration: "none",
  },
  hero: {
    background: "linear-gradient(135deg, #4318FF, #7551FF)",
    color: "#fff",
    padding: "60px 20px",
    textAlign: "center",
  },
  heroTitle: {
    fontSize: 36,
    fontWeight: 800,
    margin: "0 0 12px 0",
  },
  heroMeta: {
    fontSize: 14,
    opacity: 0.85,
    margin: 0,
  },
  content: {
    maxWidth: 800,
    margin: "0 auto",
    padding: "40px 20px",
  },
  alertBox: {
    background: "#fff3f3",
    border: "2px solid #ef4444",
    borderRadius: 12,
    padding: "20px 24px",
    marginBottom: 20,
    textAlign: "center",
  },
  alertTitle: {
    fontSize: 20,
    fontWeight: 800,
    color: "#ef4444",
    margin: "0 0 8px 0",
  },
  alertText: {
    fontSize: 14,
    color: "#7f1d1d",
    lineHeight: 1.7,
    margin: 0,
  },
  tocCard: {
    background: "#fff",
    borderRadius: 16,
    padding: "24px 28px",
    marginBottom: 20,
    boxShadow: "0 2px 10px rgba(0,0,0,0.06)",
    borderLeft: "4px solid #4318FF",
  },
  tocHeading: {
    fontSize: 15,
    fontWeight: 800,
    color: "#1b2559",
    marginBottom: 12,
    marginTop: 0,
  },
  tocList: {
    listStyle: "none",
    padding: 0,
    margin: 0,
    display: "flex",
    flexWrap: "wrap",
    gap: "6px 24px",
  },
  tocItem: {
    fontSize: 13,
    color: "#4318FF",
    textDecoration: "none",
    fontWeight: 600,
    lineHeight: 1.8,
  },
  card: {
    background: "#fff",
    borderRadius: 16,
    padding: "24px 28px",
    marginBottom: 20,
    boxShadow: "0 2px 10px rgba(0,0,0,0.06)",
  },
  sectionHeading: {
    fontSize: 17,
    fontWeight: 800,
    color: "#1b2559",
    marginBottom: 12,
    marginTop: 0,
  },
  bodyText: {
    fontSize: 14,
    color: "#374151",
    lineHeight: 2,
    margin: 0,
  },
  subHeading: {
    fontSize: 14,
    fontWeight: 700,
    color: "#1b2559",
    marginTop: 16,
    marginBottom: 6,
  },
  noRefundBanner: {
    background: "linear-gradient(135deg, #ef4444, #dc2626)",
    color: "#fff",
    borderRadius: 12,
    padding: "20px 24px",
    textAlign: "center",
    marginBottom: 20,
  },
  noRefundTitle: {
    fontSize: 22,
    fontWeight: 800,
    margin: "0 0 8px 0",
    letterSpacing: 1,
  },
  noRefundText: {
    fontSize: 14,
    opacity: 0.95,
    margin: 0,
    lineHeight: 1.7,
  },
  legalBox: {
    background: "#f0f4ff",
    border: "1px solid #c7d2fe",
    borderRadius: 8,
    padding: "12px 16px",
    fontSize: 13,
    color: "#3730a3",
    lineHeight: 1.7,
    marginTop: 12,
  },
  exceptionBox: {
    background: "#f0fdf4",
    border: "1px solid #86efac",
    borderRadius: 8,
    padding: "14px 18px",
    fontSize: 13,
    color: "#14532d",
    lineHeight: 1.8,
    marginTop: 12,
  },
  checklistItem: {
    display: "flex",
    alignItems: "flex-start",
    gap: 10,
    marginBottom: 10,
    fontSize: 14,
    color: "#374151",
    lineHeight: 1.7,
  },
  checkIcon: {
    color: "#ef4444",
    fontWeight: 800,
    marginTop: 2,
    flexShrink: 0,
  },
  footer: {
    background: "#1b2559",
    color: "#fff",
    padding: "30px 20px",
    textAlign: "center",
  },
  footerLinks: {
    display: "flex",
    justifyContent: "center",
    gap: 24,
    marginBottom: 16,
    flexWrap: "wrap",
  },
  footerLink: {
    color: "#a0aec0",
    textDecoration: "none",
    fontSize: 13,
  },
  footerText: {
    fontSize: 13,
    color: "#a0aec0",
    margin: "4px 0",
  },
};

const RefundPolicy = () => {
  return (
    <LegalLayout activePage="refund">

      {/* Hero */}
      <div style={styles.hero}>
        <h1 style={styles.heroTitle}>Refund & Cancellation Policy</h1>
        <p style={styles.heroMeta}>Effective Date: 1st January 2025 &nbsp;|&nbsp; Last Updated: 28th March 2026</p>
      </div>

      {/* Content */}
      <div style={styles.content}>

        {/* No Refund Banner */}
        <div style={styles.noRefundBanner}>
          <p style={styles.noRefundTitle}>STRICTLY NO REFUND POLICY</p>
          <p style={styles.noRefundText}>
            All subscription fees paid to FraudCheck FDS are <strong>non-refundable under any circumstances</strong> once the subscription has been activated. By completing your payment, you acknowledge and agree to this policy.
          </p>
        </div>

        {/* Intro */}
        <div style={{ ...styles.card, borderLeft: "4px solid #4318FF" }}>
          <p style={styles.bodyText}>
            This Refund and Cancellation Policy governs all subscription transactions on the FraudCheck FDS platform at <strong>fds.uvars.com</strong>. Please read this policy carefully before making any payment.
          </p>
          <p style={{ ...styles.bodyText, marginTop: 10 }}>
            This policy is established in accordance with the <strong>Indian Contract Act, 1872 (Sections 73–74)</strong>, the <strong>Consumer Protection Act, 2019</strong>, and the <strong>Information Technology Act, 2000</strong>. By completing a subscription payment, you agree to be legally bound by this policy.
          </p>
          <p style={{ ...styles.bodyText, marginTop: 10 }}>
            <strong>You expressly agreed to this Refund Policy at the time of registration (by checking the "I agree" checkbox) and again at the time of purchase.</strong> This constitutes a valid, enforceable agreement under the Indian Contract Act, 1872.
          </p>
        </div>

        {/* Table of Contents */}
        <div style={styles.tocCard}>
          <p style={styles.tocHeading}>Table of Contents</p>
          <ul style={styles.tocList}>
            {[
              ["#nature", "1. Subscription Nature"],
              ["#no-refund", "2. No Refund Policy"],
              ["#cancellation", "3. Cancellation Policy"],
              ["#exceptions", "4. Exceptions"],
              ["#dispute", "5. Dispute Resolution"],
              ["#governing", "6. Governing Law"],
              ["#contact", "7. Contact Us"],
            ].map(([href, label]) => (
              <li key={href}><a href={href} style={styles.tocItem}>{label}</a></li>
            ))}
          </ul>
        </div>

        {/* 1. Subscription Nature */}
        <div style={styles.card} id="nature">
          <h2 style={styles.sectionHeading}>1. Subscription Nature</h2>
          <p style={styles.bodyText}>
            FraudCheck FDS provides access to a fraud prevention SaaS (Software-as-a-Service) platform on a <strong>subscription basis</strong>. All subscriptions are:
          </p>
          <ul style={{ ...styles.bodyText, paddingLeft: 20, marginTop: 10 }}>
            <li style={{ marginBottom: 8 }}><strong>Annual (Yearly):</strong> All subscription plans are sold on an annual basis, providing access to the Platform for a period of 12 months from the activation date.</li>
            <li style={{ marginBottom: 8 }}><strong>Pre-paid:</strong> Payment is collected in full upfront before the subscription period begins.</li>
            <li style={{ marginBottom: 8 }}><strong>Digital Service:</strong> The subscription provides access to a digital SaaS platform and does not involve the delivery of any physical goods. As a digital service, it is governed by the digital services provisions of the <strong>Consumer Protection Act, 2019 (Section 2(9))</strong>.</li>
            <li style={{ marginBottom: 8 }}><strong>Non-transferable:</strong> Subscriptions are linked to a specific registered account and cannot be transferred to another person or business.</li>
            <li style={{ marginBottom: 8 }}><strong>Non-auto-renewing:</strong> Subscriptions do not renew automatically. You must manually renew before expiry.</li>
          </ul>
          <div style={styles.legalBox}>
            <strong>Legal Note:</strong> The subscription fee represents the agreed consideration for access to our Platform for the specified subscription period. This constitutes a valid and binding contract under <strong>Section 2(h) of the Indian Contract Act, 1872</strong>. The terms of this contract, including the no-refund policy, were presented to and accepted by you prior to purchase.
          </div>
        </div>

        {/* 2. No Refund Policy */}
        <div style={styles.card} id="no-refund">
          <h2 style={styles.sectionHeading}>2. No Refund Policy</h2>

          <div style={{ ...styles.alertBox, marginBottom: 16, textAlign: "left" }}>
            <p style={styles.alertTitle} style={{ fontSize: 16, fontWeight: 800, color: "#ef4444", margin: "0 0 8px 0" }}>
              ALL SUBSCRIPTION FEES ARE STRICTLY NON-REFUNDABLE
            </p>
            <p style={styles.alertText}>
              Once a subscription payment has been processed and the subscription has been activated, <strong>no refund will be issued under any circumstances</strong>, including but not limited to the reasons listed below.
            </p>
          </div>

          <p style={styles.bodyText}>There are NO refunds for:</p>
          <div style={{ marginTop: 12 }}>
            {[
              "You change your mind after purchasing the subscription.",
              "You did not use the Platform or used it less than expected during the subscription period.",
              "You found an alternative service or solution.",
              "You forgot about the subscription or failed to cancel before auto-renewal (subscriptions do not auto-renew; this is provided for clarity).",
              "Your subscription plan did not meet your expectations (all plan features are clearly described before purchase).",
              "Technical issues on your end, including internet connectivity problems or device incompatibility.",
              "Partial use of the subscription period — no pro-rata refunds are available.",
              "Dissatisfaction with search results or fraud database content contributed by other users.",
              "Account suspension due to violation of our Terms and Conditions.",
              "Business closure or cessation of your rental operations during the subscription period.",
              "Any other reason not specifically listed in Section 4 (Exceptions) of this policy.",
            ].map((item, i) => (
              <div key={i} style={styles.checklistItem}>
                <span style={styles.checkIcon}>✗</span>
                <span>{item}</span>
              </div>
            ))}
          </div>

          <div style={styles.legalBox}>
            <strong>Legal Basis:</strong> This no-refund policy is enforceable as a valid pre-agreed contractual term under <strong>Sections 73 and 74 of the Indian Contract Act, 1872</strong>, which recognise agreed-upon remedies and liquidated damages clauses in contracts. You agreed to this policy expressly at the time of registration and purchase. Under the <strong>Consumer Protection Act, 2019</strong>, digital service subscriptions are a recognised category of services, and the terms agreed to by the consumer at the time of purchase are enforceable.
          </div>
        </div>

        {/* 3. Cancellation Policy */}
        <div style={styles.card} id="cancellation">
          <h2 style={styles.sectionHeading}>3. Cancellation Policy</h2>
          <p style={styles.bodyText}>
            You may choose to stop using FraudCheck FDS at any time. However, please note the following:
          </p>

          <p style={styles.subHeading}>3.1 Cancellation by You</p>
          <p style={styles.bodyText}>
            If you wish to cancel your subscription, you may do so by ceasing to use the Platform. Your account and subscription will remain active and accessible until the end of your current subscription period, after which it will not renew.
          </p>
          <p style={{ ...styles.bodyText, marginTop: 10 }}>
            <strong>Cancellation does not entitle you to any refund for the unused portion of the subscription period.</strong> Your access to the Platform continues until the subscription expiry date, regardless of whether you actively use it.
          </p>

          <p style={styles.subHeading}>3.2 Cancellation by FraudCheck FDS</p>
          <p style={styles.bodyText}>
            We reserve the right to terminate or suspend your subscription account, without refund, if you are found to be in violation of our Terms and Conditions, including but not limited to:
          </p>
          <ul style={{ ...styles.bodyText, paddingLeft: 20, marginTop: 8 }}>
            <li style={{ marginBottom: 6 }}>Submitting false, fabricated, or malicious fraud reports.</li>
            <li style={{ marginBottom: 6 }}>Misusing Platform data for purposes outside fraud prevention.</li>
            <li style={{ marginBottom: 6 }}>Providing false registration information.</li>
            <li style={{ marginBottom: 6 }}>Any other material breach of our Terms and Conditions.</li>
          </ul>

          <p style={styles.subHeading}>3.3 Platform Discontinuation</p>
          <p style={styles.bodyText}>
            In the event that FraudCheck FDS permanently discontinues the Platform during an active subscription period, we will make a good-faith effort to provide a pro-rata refund for the remaining unused subscription period. This is the only circumstance under which a refund may be considered outside of Section 4 below.
          </p>
        </div>

        {/* 4. Exceptions */}
        <div style={styles.card} id="exceptions">
          <h2 style={styles.sectionHeading}>4. Exceptions — When a Refund May Be Considered</h2>
          <p style={styles.bodyText}>
            <strong>The only exception</strong> to our no-refund policy is in the case of a verifiable administrative or technical error by FraudCheck FDS that resulted in your subscription being charged but never activated:
          </p>
          <div style={styles.exceptionBox}>
            <strong>Eligible Exception:</strong> If you made a subscription payment and your subscription was <strong>never activated due to a confirmed error on our part</strong> (for example, a payment gateway processing error that charged you but did not register the payment on our system, and your account remained in an inactive/unactivated state), you may be entitled to a full refund.
            <br /><br />
            To claim this exception, you must:
            <ol style={{ paddingLeft: 20, marginTop: 8, marginBottom: 0 }}>
              <li style={{ marginBottom: 4 }}>Contact us within <strong>7 days</strong> of the payment date.</li>
              <li style={{ marginBottom: 4 }}>Provide proof of payment (transaction ID, bank statement screenshot).</li>
              <li style={{ marginBottom: 4 }}>Confirm that your account was never activated and you were unable to access Platform features.</li>
            </ol>
          </div>
          <p style={{ ...styles.bodyText, marginTop: 12 }}>
            This exception does <strong>not</strong> apply if:
          </p>
          <ul style={{ ...styles.bodyText, paddingLeft: 20, marginTop: 8 }}>
            <li style={{ marginBottom: 6 }}>Your subscription was activated and you used the Platform even briefly.</li>
            <li style={{ marginBottom: 6 }}>You made a duplicate payment intentionally or due to your own error (contact us to resolve duplicate payment issues separately).</li>
            <li style={{ marginBottom: 6 }}>More than 7 days have passed since the payment date.</li>
          </ul>
          <p style={{ ...styles.bodyText, marginTop: 12 }}>
            All exception claims are reviewed on a case-by-case basis and the final decision rests solely with FraudCheck FDS. Approval of an exception refund is not guaranteed and is at our sole discretion.
          </p>
        </div>

        {/* 5. Dispute Resolution */}
        <div style={styles.card} id="dispute">
          <h2 style={styles.sectionHeading}>5. Dispute Resolution</h2>
          <p style={styles.bodyText}>
            We are committed to resolving all complaints and disputes fairly and efficiently. If you have a concern about a payment or subscription, please follow this process:
          </p>

          <p style={styles.subHeading}>Step 1 — Contact Us Directly</p>
          <p style={styles.bodyText}>
            Email us at <a href="mailto:admin.umasankar@gmail.com" style={{ color: "#4318FF", fontWeight: 600 }}>admin.umasankar@gmail.com</a> with your registered email address, subscription details, payment proof, and a clear description of your concern. We will respond within <strong>5 business days</strong>.
          </p>

          <p style={styles.subHeading}>Step 2 — Escalation</p>
          <p style={styles.bodyText}>
            If your concern is not resolved to your satisfaction through direct communication, you may escalate the matter to our Grievance Officer using the same contact details. Grievances will be addressed within 30 days.
          </p>

          <p style={styles.subHeading}>Step 3 — Consumer Disputes Redressal Commission</p>
          <p style={styles.bodyText}>
            If the dispute remains unresolved after exhausting the above steps, you have the right to approach the appropriate <strong>Consumer Disputes Redressal Commission</strong> under the <strong>Consumer Protection Act, 2019</strong>. The appropriate forum is determined by the value of the claim:
          </p>
          <ul style={{ ...styles.bodyText, paddingLeft: 20, marginTop: 8 }}>
            <li style={{ marginBottom: 6 }}>District Consumer Disputes Redressal Commission — for claims up to ₹1 Crore</li>
            <li style={{ marginBottom: 6 }}>State Consumer Disputes Redressal Commission — for claims between ₹1 Crore and ₹10 Crore</li>
            <li style={{ marginBottom: 6 }}>National Consumer Disputes Redressal Commission — for claims above ₹10 Crore</li>
          </ul>
          <p style={{ ...styles.bodyText, marginTop: 10 }}>
            The jurisdiction for any legal proceedings is <strong>Andhra Pradesh / Telangana, India</strong>, as specified in our Terms and Conditions.
          </p>

          <p style={styles.subHeading}>Chargeback Policy</p>
          <p style={styles.bodyText}>
            Initiating an unauthorized chargeback with your bank or payment gateway without first attempting to resolve the issue with us directly is a violation of our Terms and Conditions. Such chargebacks may result in immediate account suspension and may be contested with full documentary evidence of your acceptance of this Refund Policy at the time of purchase.
          </p>
        </div>

        {/* 6. Governing Law */}
        <div style={styles.card} id="governing">
          <h2 style={styles.sectionHeading}>6. Governing Law</h2>
          <p style={styles.bodyText}>
            This Refund and Cancellation Policy is governed by and construed in accordance with the <strong>Laws of India</strong>, including:
          </p>
          <ul style={{ ...styles.bodyText, paddingLeft: 20, marginTop: 10 }}>
            <li style={{ marginBottom: 8 }}>
              <strong>Indian Contract Act, 1872 (Sections 73–74)</strong> — The no-refund policy constitutes an agreed-upon contractual term for liquidated damages/consideration, which was accepted by you at the time of purchase.
            </li>
            <li style={{ marginBottom: 8 }}>
              <strong>Consumer Protection Act, 2019 (Section 2(9))</strong> — FraudCheck FDS is a digital service provider and this policy is consistent with consumer protection provisions applicable to digital services and SaaS platforms.
            </li>
            <li style={{ marginBottom: 8 }}>
              <strong>Information Technology Act, 2000</strong> — All electronic contracts and agreements formed through our Platform are valid and binding under this Act.
            </li>
          </ul>
          <p style={{ ...styles.bodyText, marginTop: 12 }}>
            All disputes arising from this policy shall be subject to the exclusive jurisdiction of the competent courts in <strong>Andhra Pradesh / Telangana, India</strong>.
          </p>
        </div>

        {/* 7. Contact */}
        <div style={styles.card} id="contact">
          <h2 style={styles.sectionHeading}>7. Contact Us</h2>
          <p style={styles.bodyText}>
            For any questions, concerns, or exception requests under this Refund Policy, please contact us:
          </p>
          <div style={{ marginTop: 16 }}>
            <p style={{ ...styles.bodyText, marginBottom: 8 }}><strong>Platform:</strong> FraudCheck FDS</p>
            <p style={{ ...styles.bodyText, marginBottom: 8 }}><strong>Website:</strong> <a href="https://fds.uvars.com" style={{ color: "#4318FF", fontWeight: 600 }}>fds.uvars.com</a></p>
            <p style={{ ...styles.bodyText, marginBottom: 8 }}><strong>Email:</strong> <a href="mailto:admin.umasankar@gmail.com" style={{ color: "#4318FF", fontWeight: 600 }}>admin.umasankar@gmail.com</a></p>
            <p style={{ ...styles.bodyText, marginBottom: 8 }}><strong>Phone:</strong> <a href="tel:7207270218" style={{ color: "#4318FF", fontWeight: 600 }}>7207270218</a></p>
            <p style={{ ...styles.bodyText, marginBottom: 8 }}><strong>Jurisdiction:</strong> Andhra Pradesh / Telangana, India</p>
            <p style={{ ...styles.bodyText, marginBottom: 0 }}><strong>Response Time:</strong> Within 5 business days for all refund/payment queries</p>
          </div>
        </div>

        {/* Final Acknowledgement */}
        <div style={{ ...styles.card, background: "#1b2559", borderRadius: 16 }}>
          <p style={{ fontSize: 15, fontWeight: 800, color: "#fff", marginBottom: 10, marginTop: 0 }}>
            By using FraudCheck FDS, you acknowledge:
          </p>
          {[
            "You have read, understood, and agreed to this Refund and Cancellation Policy in full.",
            "You agreed to this policy at the time of account registration by checking the 'I agree' checkbox.",
            "You agreed to this policy again at the time of payment before completing your subscription purchase.",
            "All subscription fees are non-refundable once payment has been processed and the subscription activated.",
            "This policy is a legally binding contractual term under the Indian Contract Act, 1872.",
          ].map((item, i) => (
            <div key={i} style={{ display: "flex", alignItems: "flex-start", gap: 10, marginBottom: 8, fontSize: 13, color: "#a0aec0", lineHeight: 1.7 }}>
              <span style={{ color: "#7551FF", fontWeight: 800, flexShrink: 0 }}>✓</span>
              <span>{item}</span>
            </div>
          ))}
        </div>

      </div>

      <LegalFooter />
    </LegalLayout>
  );
};

export default RefundPolicy;
